import axios from 'axios';
import { config } from '../apiConfig';

const FinalizeCheckoutdReserves = async () => {
    let result = [];
    let response = await axios.get(`${config.url}/api/mvc/UserProfile/GetFinalizeCheckoutdReserves`).catch((error) => {
        if (error.response.status === 401) {
            result.status = error.response.status;
            result.data = 'unauthorized';
            return result;
        }
    });
    result.status = response.status;
    result.data = response.data.length > 0 ? response.data : 'empty';
    return result;
}

export default FinalizeCheckoutdReserves;